import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function ClientBrief() {
  return (
    <section className="client__brief p-100">
      <Container>
        <Row>
          <Col xs={12} md={12} lg={10} className="m-auto text-center">
            <h2 style={{ color: "#000" }}>
              Client <span style={{ color: "#DB2F91" }}>Brief</span>
            </h2>
            <p>
              ButtonSmasher is a complete solution for gaming enthusiasts. With
              an authentic rating and review system, it provides a way for
              gamers to stay updated with the latest news in the game industry.
              Button Smasher is a trusted platform for gamers to unite and share
              experiences to keep the game going!
            </p>
            <h2 style={{ color: "#000" }}>Mission</h2>
            <div className="mission_boxes">
              <div className="mission_box">
                YEAR - <span style={{ color: "#DB2F91" }}> 2019</span>
              </div>
              <div className="mission_box">
                ROLE - <span style={{ color: "#DB2F91" }}> UI/UX DESIGN</span>
              </div>
              <div className="mission_box">
                TYPE -
                <span style={{ color: "#DB2F91" }}>
                  {" "}
                  Mobile Application and Website
                </span>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default ClientBrief;
